import axios from 'axios';
import {ENDPOINT} from 'constants';

const BASE_URL = `${ENDPOINT}api/v1/admin-ops/error-logs`;

const authHeaders = accessToken => ({
  headers: {Authorization: `Bearer ${accessToken}`},
});

export const errorLogsApi = {
  fetchLogs: async (accessToken, params = {}) => {
    const {data} = await axios.get(BASE_URL, {
      ...authHeaders(accessToken),
      params,
    });
    return data?.data;
  },

  fetchLogById: async (accessToken, id) => {
    const {data} = await axios.get(`${BASE_URL}/${id}`, authHeaders(accessToken));
    return data?.data;
  },

  deleteLog: async (accessToken, id) => {
    const {data} = await axios.delete(`${BASE_URL}/${id}`, authHeaders(accessToken));
    return data;
  },

  clearAllLogs: async accessToken => {
    const {data} = await axios.delete(BASE_URL, authHeaders(accessToken));
    return data;
  },
};
